
/**
 * @description
 * 로드맵 상세 > 관련 수업 > 수업 아이템의 오더링 or 이미 들음 플래그
 */
export default {
  name: 'OrderOrFlag',
  props: {
    order: { type: Number, default: 0 },
    isPurchased: { type: Boolean, default: false },
  },
};
